// Packages
import React, { useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { FormattedMessage } from 'react-intl';
// Icons, Images etc.
import loyaltyImageAnimation from "../../images/placeorder-loyalty.svg";
import placeOrderAnimation from "../../images/food-delivery-noloyalty.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleRight } from "@fortawesome/free-solid-svg-icons";
// Helpers, Utils etc.
import { formatDecimal } from "../../helpers/itemCalculations";
import { getSubdomainPath } from "../../helpers/pathUtils";

interface IOrderPlacedPopupProps {
  currency: any;
  earnedLoyalty: any;
}

function OrderPlacedPopup(props: IOrderPlacedPopupProps) {
  const [show, setShow] = useState(true);
  const history = useHistory();

  const handleTrackOrder = () => {
    const trackOrderPath = getSubdomainPath("/m/trackorder");
    history.push(trackOrderPath);
  };

  return (
    <Modal show={show} centered backdrop="static">
      <div className="order-placed-popup-mobile">
        {Number(props.earnedLoyalty) ? (
          <React.Fragment>
            <div className="loyalty-icon">
              <object type="image/svg+xml" data={loyaltyImageAnimation}></object>
            </div>
            <p className="greetings">
              <FormattedMessage
                id="order.thank_you_for_placing_an_order"
                defaultMessage="Thank you for placing an order with us!"
              />
            </p>
            <p className="loyalty-info">
              <FormattedMessage
                id="order.you_have_earned_loyalty"
                defaultMessage="You have earned <spanTag>{earnedLoyalty} Loyalty {currency}</spanTag> from your order"
                values={{
                  earnedLoyalty: formatDecimal(props.earnedLoyalty),
                  currency: props.currency,
                  spanTag: (text) => <span>{text}</span>,
                }}
              />
            </p>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className="loyalty-icon">
              <object type="image/svg+xml" data={placeOrderAnimation}></object>
            </div>
            <p className="greetings">
              <FormattedMessage
                id="order.thank_you_for_placing_an_order"
                defaultMessage="Thank you for placing an order with us!"
              />
            </p>
          </React.Fragment>
        )}
        <button
          className="btn button btn-primary w-100"
          onClick={handleTrackOrder}
        >
          <FormattedMessage
            id="order.track_order"
            defaultMessage="Track Order"
          />
          <span className="ml-2">
            <FontAwesomeIcon icon={faChevronCircleRight} />
          </span>
        </button>
      </div>
    </Modal>
  );
}

const mapStateToProps = (state: any) => {
  let currency = state.company.currency;

  return { currency };
};

export default connect(mapStateToProps)(OrderPlacedPopup);
